import React, { useState, useContext } from 'react';
import { Card } from '../../../../../components/Card/Card';
import { Event } from '../../../../../model/event';
import { useSelectedMembership } from '../../../../../model/membership';
import { ContingentEditForm } from '../../../../../components/Seatmap/ContingentEditForm';
import { ContingentList } from '../../../../../components/Seatmap/ContingentList';
import { Modal } from '../../../../../components/Modal/Modal';
import { Split } from '../../../../../components/Split/Split';
import { Button } from '../../../../../components/Button/Button';
import { t } from '../../../../../locales/translate';
import { ActivitiesContext } from '../../../../../components/Activities/Activities';
import { Stack } from '../../../../../components/Stack/Stack';
import { Spacer } from '../../../../../components/Spacer/Spacer';

interface Props {
  event: Event;
  section: { id: string; name: string };
}

export function GeneralAdmissionAllocation({ event, section }: Props): JSX.Element {
  const membership = useSelectedMembership();
  const observerMode = membership && membership.role === 'observer';
  const [editContingent, setEditContingent] = useState(false);
  const { reloadActivities } = useContext(ActivitiesContext);

  return (
    <Card title={section.name}>
      <Spacer size="xs" />
      <Split ratio={0.8}>
        <ContingentList event={event} section={section} allowEditingCapacity />
        {!observerMode && (
          <Stack>
            <h3>{t.model.contingent.createPools}</h3>
            <p>{t.model.contingent.createPoolsExplanation}</p>
            <Button
              type="primary"
              title={t.model.contingent.createPoolButton}
              onClick={() => setEditContingent(true)}
            />
          </Stack>
        )}
      </Split>
      <Modal open={editContingent} position="aside" size="small" title={t.model.contingent.editContingent}>
        {() => (
          <ContingentEditForm
            event={event}
            section={section}
            onDeselect={() => {
              setEditContingent(false);
              reloadActivities();
            }}
          />
        )}
      </Modal>
    </Card>
  );
}
